import React from 'react'
import Header from "../components/header/header";
import SeoManagement from "../sections/SeoManagement/SeoManagement"
import Footer from "../components/footer/footer";

function Seomanagement() {
    return (
        <>
            <Header />
            <SeoManagement />
            <Footer />
        </>
    )
}

export default Seomanagement
